import OnboardingLayout from "../OnboardingLayout";
import type { CategoryItem } from "./CategoryGrid";
import CategoryGrid from "./CategoryGrid";

type Props = {
	items: CategoryItem[];
	selectedId?: string;
	onSelect: (id: string) => void;
	handleNext: () => void;
	disabled?: boolean;
	progress?: number;
	selectedCategoryName?: string;
	cta?: string;
};

const CategoryChooseScreen = ({
	items,
	selectedId,
	onSelect,
	handleNext,
	disabled,
	selectedCategoryName,
	cta,
}: Props) => {
	const primaryActionLabel =
		selectedCategoryName && cta
			? cta.replace("{{category}}", selectedCategoryName)
			: "Continue";
	return (
		<OnboardingLayout
			onPrimaryPress={handleNext}
			disabled={disabled}
			primaryActionLabel={primaryActionLabel}
		>
			<CategoryGrid items={items} selectedId={selectedId} onSelect={onSelect} />
		</OnboardingLayout>
	);
};

export default CategoryChooseScreen;
